import React from 'react';
import { LineChart } from '../../../../ui-components/data-viz-ui/charts/line-chart/LineChart';
import { OverTimeSegmentedLineChartUiComponentProps } from './types';

export const OverTimeSegmentedLineChartUiComponent = (
  props: OverTimeSegmentedLineChartUiComponentProps
) => {
  return (
    <LineChart
      {...props}
      displayConfig={{ ...props.displayConfig, enableSortOrder: false }}
    />
  );
};
